<template>
    <div class="max" data-view="strat.rtco.highlights.v12019">
        <div class="actions">
            <v-layout fill-height align-center justify-center wrap>
                <div style="">
                    <v-layout fill-height align-center justify-center wrap>
                        <v-flex xs12>
                            <v-btn icon color="primary" :disabled="reset || co == 0" @click="lastSection()" v-if="co == 0">
                                <v-icon size="32">arrow_upward</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="last()" v-else>
                                <v-icon size="32">arrow_upward</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 mt-8>
                            <v-btn icon color="primary" @click="nextSection()" v-if="co == (coLength-1)">
                                <v-icon size="32">arrow_downward</v-icon>
                            </v-btn>
                            <v-btn icon color="primary" @click="next()" v-else>
                                <v-icon size="32">arrow_downward</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </div>
            </v-layout>
        </div>
        <!-- <div class="page-title" style="position: fixed; left: 8%; top: 8%; z-index: 3">
            <v-card flat color="transparent">
                <v-card-text class="ls8 text-uppercase">Company Overview</v-card-text>
                <v-card-title class="font-weight-black black--text">
                    <span class="text-uppercase" style="font-size:10em; line-height: 168px">
                        Dolo<br><span class="ls12">Labs</span>
                    </span>
                </v-card-title>
            </v-card>
        </div> -->
        <div class="section-title">
            <v-layout fill-height align-end justify-center>
                <div class="text-uppercase grey--text">
                    <div class="main-title font-weight-black ls8">Company Overview</div>
                    <div class="subtitle font-weight-black ls8 anton">Dolo<br><span class="font-weight-light">Labs</span></div>
                </div>
            </v-layout>
        </div>
        <v-layout row wrap style="z-index: 1">
            <v-card flat class="max pa-0" color="transparent">
                <div class="pl-8">
                    <v-card-text class="pt-2">
                        <v-card height="4" width="35" color="amber" flat></v-card>
                    </v-card-text>
                    <v-card-text class="mt-12 t12 text-uppercase grey--text pb-0">
                        Topics
                    </v-card-text>
                    <v-card-text class="pa-0 pr-12 mb-6 ml-n8">
                        <v-list shaped>
                            <v-list-item-group v-model="co" color="primary">
                                <v-list-item
                                    v-for="(m, i) in coMenu"
                                    :key="i"
                                    @click="setWindow(i)"
                                    class="py-0 mb-0"
                                >
                                <v-list-item-content class="py-0 pl-8 mb-0">
                                    <v-list-item-title v-text="m" class="s-menu-item" :class="co == i ? 't18 amber--text v-item--active v-list-item--active ' : ' t12'"></v-list-item-title>
                                </v-list-item-content>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card-text>
                    <!-- <v-card-text class="t12 text-uppercase grey--text">
                        Company Highlights
                    </v-card-text>
                    <v-card-text class="t20 font-weight-light py-0 text-uppercase black--text mb-3">
                        <v-layout align-center>
                            <v-avatar tile size="20">
                                <v-img contain :src="require('../../../assets/dolodots.png')"></v-img>
                            </v-avatar>
                            <span class="font-weight-black">Dolo</span>Labs LLC
                        </v-layout>
                    </v-card-text>
                    <v-card-text class="t12 py-0 text-uppercase black--text">
                        <span class="grey--text">Headquarters</span> • Dallas, Tx
                    </v-card-text>
                    <v-card-text class="t12 py-0 text-uppercase black--text">
                        <span class="grey--text">Founded</span> • August 14, 2019
                    </v-card-text>
                    <v-card-text class="t12 py-0 text-uppercase black--text">
                        <span class="grey--text">Founders</span> • Josh Olson
                    </v-card-text>
                    <v-card-text class="t12 py-0 text-uppercase black--text">
                        <span class="grey--text">Employees</span> • 2
                    </v-card-text>
                    <v-card-text class="t12 py-0 text-uppercase black--text">
                        <span class="grey--text">Annual Revenue</span> • Pre-Revenue
                    </v-card-text>
                    <v-card-text class="t12 py-0 text-uppercase black--text">
                        <span class="grey--text">Categories</span>
                    </v-card-text>
                    <v-card-text class="t12 py-0 text-uppercase black--text pr-10">
                        <v-chip-group
                            multiple
                            column
                            active-class="primary--text"
                        >
                            <v-chip outlined v-for="(tag, i) in tags" :key="i" class="t8" small>
                                {{ tag }}
                            </v-chip>
                        </v-chip-group>
                    </v-card-text> -->
                </div>
            </v-card>
        </v-layout>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        reset: Boolean,
    },
    data: () => {
        return {
            co: 0,
            coLength: 3,
            coMenu: ['Who are we?', 'The Team', 'Our Mission'],
            tags: ['Enterprise Software', 'Information Technology', 'Performance Management', 'Education', 'Employment', 'Human Resources', 'Cloud Solutions', 'Recruiting', 'Online Portals', 'collaboration', 'SaaS', 'Software', 'Mobile Apps', 'Publishing', 'Task Management']
        }
    },
    mounted(){
        if(this.reset) {
            this.co = 0
            //eslint-disable-next-line
            console.log('company-highlights.mounted this reset = '+this.reset+' co = '+this.co)
        }
    },
    methods: {
        last(){
            if(this.co == 0){
                this.co = 2
                this.$emit('last', this.co, 'co')
                //eslint-disable-next-line
                console.log('company-highlights.methods.last.if -- emmitting : '+this.co)

            } else {
                this.co = this.co - 1
                this.reset = false
                this.$emit('last', this.co, 'co')
                //eslint-disable-next-line
                console.log('company-highlights.methods.last.else -- emmitting : '+this.co)
            }
        },
        lastSection(){
            this.$emit('lastSection')
        },
        next(){
            if(this.co == (this.coLength - 1)){
                this.co = 0
                this.reset = false
                this.$emit('next', this.co, 'co')
                //eslint-disable-next-line
                console.log('company-highlights.methods.next.if -- emmitting : '+this.co)
            } else {
                this.co = this.co + 1
                this.reset = false
                this.$emit('next', this.co, 'co')
                //eslint-disable-next-line
                console.log('company-highlights.methods.next.else -- emmitting : '+this.co)
            }
        },
        nextSection(){
            this.$emit('nextSection')
        },
        setWindow(i) {
            this.co = i
            this.$emit('setWindow', i, 'co')
        }
    }
}
</script>

<style lang="scss">
    .actions {
        position: absolute;
        left: 28px;
        width: 50px;
        height: 100%;
        z-index: 1;
    }

    .section-title {
        position: absolute;
        height: 100%;
        top: 0;
        left: -14px;
        width: 100px;

        .title {
            transform: rotate(-90deg);

            .main-title {
                opacity: .16s;
            }

            .subtitle {
                font-size: 12em;
                opacity: .07
            }
        }
    }

    .s-menu-item{
        transition: all .35s
    }
</style>